import Select, { Props as ReactSelectProps } from 'react-select'

import * as S from "./styles";
import { FocusEvent } from 'react';

type Props<T> = ReactSelectProps<T> & {
  label?: string;
  error?: string;
  apiErrorName?: string;
  handleApiErrorRemove?: () => void;
};

function AutoComplete<T extends unknown>({
  label,
  apiErrorName,
  handleApiErrorRemove,
  error,
  ...reactSelectProps
}: Props<T>) {
  function handleBlur(event: FocusEvent<HTMLInputElement, Element>) {
    if (reactSelectProps.onBlur) {
      reactSelectProps.onBlur(event);
    }

    if (handleApiErrorRemove) {
      handleApiErrorRemove()
    }
  }

  return (
    <S.Wrapper>
      <label htmlFor={reactSelectProps.id}>
        {label}
      </label>

      <Select
        classNames={{
          option: () => 'react-select-option'
        }}
        aria-label={label}
        {...reactSelectProps}
        styles={S.reactSelectStyles}
        onBlur={handleBlur}
      />

      {error && <small>{error}</small>}
    </S.Wrapper>
  );
}

export { AutoComplete };
